<template>
  <div>
    <el-row type="flex" class="title-bar" justify="end">
      <div>
        <w-header-search-button size="mini" @click="majorShowSearchTool = !majorShowSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :data="majorPortTableData" :columns="majorColumns" :column-default="columnDefault" ref="majorTableRef"
     :show-custom-header="true" :show-search-tool="majorShowSearchTool" :pagination="true">
       <template slot-scope="scope" slot="status-slot">
         <span v-if="scope.row['servicePortStatus'] != null" :class="getStatusAliveClass(scope.row['servicePortStatus'])">{{statusAliveFormatter(scope.row['servicePortStatus'])}}</span>
         <el-tooltip v-else effect="dark" content="자원 미수집" placement="top"><span> - </span></el-tooltip>
       </template>
    </el-table-wrapper>
  </div>
</template>

<script>
import { columnDefault } from '@/constants/table';
import { mapGetters } from 'vuex';
import { isNil } from 'lodash';
import ServiceAPI from '@/api/performance/service/service';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertMillisecondsToSeconds } from '@/utils/number';

export default {
  name: 'WServiceMajorPortList',
  props: {
    active: {
      type: Boolean,
    },
  },
  data() {
    return {
      columnDefault,
      majorShowSearchTool: false,
      majorPortTableData: [],
      majorColumns: [
        { prop: 'servicePortStatus', label: '동작 상태', width: 90, sortable: true, scopedSlot: 'status-slot' },
        { prop: 'managetypeName', label: '관리타입', width: 120 },
        { prop: 'objName', label: '장비명', width: 250, sortable: true, searchable: true },
        { prop: 'serviceName', label: '서비스 포트 이름', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'netPortNumn', label: '서비스 포트 번호', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'serviceResptime', label: '응답 시간', width: 180, formatter: this.getConvertValuByUnit },
      ],
    };
  },
  computed: {
    ...mapGetters(['selectedNode']),
  },
  watch: {
    active: {
      handler(value) {
        if (value) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    loadData() {
      if (!this.active) {
        return;
      }
      // table
      ServiceAPI.getServiceMajorPortList({ serviceId: this.selectedNode.obj.objId }).then((res) => {
        if (res.data.success) {
          this.majorPortTableData = res.data.data;
        }
      });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    statusAliveFormatter(value) {
      if (isNil(value)) { return EMPTY_TEXT; }
      switch (value) {
        case '0' : return '다운상태';
        case '1' : return '정상';
        default: return EMPTY_TEXT;
      }
    },
    getStatusAliveClass(value) {
      if (value === '0') {
        return 'state-abnormal';
      } else if (value === '1') {
        return 'state-normal';
      }
      return '';
    },
    getConvertValuByUnit(row, column, value) {
      if (value < 0) {
        return EMPTY_TEXT;
      }
      return convertMillisecondsToSeconds(value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/operation/service/components/ServiceMajorPortList.vue